<template>
    <div>
        <store-special-index v-show="special && special['store/index'+store.store_id]" :page-path="'store/index'" :item-id="''"></store-special-index>
<div class="container" v-show="!special || !special['store/index'+store.store_id]">

    <div class="header" :style="{backgroundImage:'url('+store.mb_title_img+')'}">
        <div class="content-wrapper">
            <div class="avatar" @click="goStoreabout">
                <img :src="store.store_avatar">
            </div>
            <div class="content">
                <div class="store_name">{{store.store_name}}<span class="ml-5" v-if="(store.is_platform_store && config.business_licence) || store.business_licence_number_electronic" @click="imageVisible=true"><i class="iconfont">&#xe621;</i></span></div>
                <div class="store_address" v-if="store.store_address" @click="$router.push({name:'HomeStoremap',query:{id:store.store_id}})">
                    <span class="iconfont">&#xe6d3;</span>
                    <span v-if="store.store_address">{{store.store_address}}</span>
                </div>
            </div>
            <div class="follow_panel">
                <div class="follow_button" @click="toggleFavorite" >
                    <i class="iconfont" :class="{'active':store.is_favorate}"  v-html="favoriteIco"></i>
                    {{favoriteName}}
                </div>
                <div class="follow_number">
                    {{store.store_collect}} collection
                </div>
            </div>
            <i class="header-more iconfont" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div></i>
        </div>
        <div class="background">
            <img v-if="store.store_logo" v-lazy="store.store_logo" width="100%" height="100%">
            <img v-else v-lazy="store.store_logo" width="100%" height="100%">
        </div>
    </div>
    <header-more v-show="popupVisible" :showDot="showDot"></header-more>
    <!--直播start-->
    <div class="box-wrapper h live-wrapper"  v-if="store.live_apply_info" @click="goLive(store.live_apply_info.live_apply_id)">
        <div class="box-wrapper v live-back-wrapper">
            <img :src="store.live_apply_info.live_apply_cover_image_url" class="live-back-image" />
            <div class="box-wrapper v live-back-cover"></div>
        </div>
        <div class="box-wrapper v left">
            <div class="box-wrapper v live-image">
                <video v-if="store.live_apply_info.live_apply_cover_video" :src="store.live_apply_info.live_apply_cover_video_url" muted="muted" autoplay="autoplay" loop="loop" />
                <img v-else :src="store.live_apply_info.live_apply_cover_image_url">
            </div>
            <span class="live-store">Shop live</span>
        </div>
        <div class="box-wrapper v right">
            <div class="box-wrapper v live-info">
                <div class="box-wrapper v live-btn">
                    <span class="live-btn-text">Watch now</span>
                </div>
                <span class="live-title">{{store.live_apply_info.live_apply_name}}</span>
                <div class="box-wrapper v live-desc">
                    <span class="live-count">{{store.live_apply_info.live_apply_view_count}} views</span>
                    <img src="../../../assets/image/live/live-state.png" class="live-icon" />
                </div>
            </div>
            <div class="box-wrapper h goods-list" v-if="store.live_apply_info.goods_list">
                <div class="box-wrapper v goods-wrapper" v-for="item in store.live_apply_info.goods_list" :key="item.goods_id">
                    <img :src="item.goods_image_url" class="goods-image" />
                    <div class="box-wrapper h goods-price">
                        <span class="currency">$</span>
                        <span class="price">{{item.goods_price}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--直播end-->
    <mt-swipe class="mt-5" v-if="store.mb_sliders && store.mb_sliders.length" v-bind:style="getBannerStyle" :showIndicators="isShowIndicators">
        <mt-swipe-item v-for="(item, index) in store.mb_sliders" :key="index">
            <img :style="getBannerStyle" v-lazy="item.imgUrl" @click="goAd(item)">
        </mt-swipe-item>
    </mt-swipe>

    <store-seckill-list
        :items="seckill_goods_list"
        v-if="seckill_goods_list && seckill_goods_list.length > 0"
    ></store-seckill-list>

    <store-product-list
            :items="rec_goods_list"
            v-if="rec_goods_list && rec_goods_list.length > 0"
    ></store-product-list>
    <common-store-footer :store_id="store.store_id"></common-store-footer>
    <mt-popup v-model="imageVisible" popup-transition="popup-fade" class="middle-popup">
        <img v-if="store.business_licence_number_electronic" :src="store.business_licence_number_electronic">
        <img v-if="store.is_platform_store && config.business_licence" :src="config.business_licence">
    </mt-popup>
</div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import StoreSpecialIndex from '../storespecial/Index'
import CommonStoreFooter from '../common/CommonStoreFooter'
import { getStoreInfo } from '../../../api/homestoredetail'
import { getChatCount } from '../../../api/memberInstantMessage'
import { addFavoriteStore, delFavoriteStore } from '../../../api/memberFavorite'
import StoreSeckillList from './StoreSeckillList'
import StoreProductList from './StoreProductList'
import HeaderMore from '../../HeaderMore'
export default {
  name: 'Storedetail',
  data () {
    return {
      imageVisible: false,
      store: {
        store_id: this.$route.query.id ? this.$route.query.id : ''
      },
      rec_goods_list: false,
      seckill_goods_list: false,
      popupVisible: false, // 弹出更多
      showDot: false
    }
  },
  components: {
    HeaderMore,
    StoreSeckillList,
    StoreProductList,
    CommonStoreFooter,
    StoreSpecialIndex
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      token: state => state.member.token,
      isOnline: state => state.member.isOnline
    }),
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width * (94.0 / 188.0)
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    isShowIndicators () {
      if (this.store.mb_sliders && this.store.mb_sliders.length > 1) {
        return true
      }
      return false
    },
    favoriteIco () {
      return this.store.is_favorate ? '&#xe64d;' : '&#xe64e;'
    },
    favoriteName () {
      return this.store.is_favorate ? 'Collected' : 'Collect'
    }
  },
  created () {
    getStoreInfo(
      this.store.store_id, this.token
    ).then((res) => {
      this.store = res.result.store_info
      this.seckill_goods_list = res.result.seckill_goods_list
      this.rec_goods_list = res.result.rec_goods_list
      if (this.store.is_platform_store) {
        this.fetchConfig({}).then(
          response => {
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }).catch(function (error) {
    })
    if (this.isOnline) {
      getChatCount().then(res => {
        if (res.result) {
          if (!this.showDot) {
            this.showDot = {}
          }
          this.showDot['chat'] = true
        }
      })
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    goLive (live_apply_id) {
      this.$router.push({ 'name': 'MemberLiveDetail', 'query': { 'live_apply_id': live_apply_id } })
    },
    goAd (item) {
      if (item.type === 2) {
        this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.link } })
      } else {
        window.location.href = item.link
      }
    },
    goStoreabout: function () {
      this.$router.push({ name: 'HomeStoreabout', query: { id: this.$route.query.id } })
    },
    // 弹出更多
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    },
    toggleFavorite () {
      if (!this.store.is_favorate) {
        addFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      } else {
        delFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }
  }

}
</script>

<style scoped>
.dot{position:absolute;width:.5rem;height:.5rem;background:red;border-radius:50%;top:.2rem;right:0;}
    .header {background: rgba(7,17,27,.5);color: #fff;overflow: hidden;position: relative;background-position: center;background-size: auto 100%;}
    .header .content-wrapper {-ms-flex-align: center;-webkit-box-align: center;align-items: center;display: -webkit-box;display: -ms-flexbox;display: flex;padding:0.8rem 0.4rem;position: relative;}
    .header .content-wrapper .avatar {-ms-flex: 0 0 3rem;-webkit-box-flex: 0;flex: 0 0 3rem;margin-right:0.4rem;width:3rem;}
    .header .content-wrapper .avatar img {border-radius:0.1rem;width:3rem;height:3rem;}
    .header .content-wrapper .content {position:relative;width:5.6rem;}
    .header .content-wrapper .content .store_name {font-size:.8rem;font-weight: 700;margin-bottom:.4rem;}
    .header .content-wrapper .content .store_address span{font-size: .7rem}
    .follow_panel{position:absolute;top:1rem;right:2rem;}
    .follow_panel .follow_button{display:block;background:#e93b3d;border-radius:2.5rem;padding:0 0.4rem;line-height:1.2rem;font-size:0.6rem;color:#fff;}
    .follow_panel .follow_button i{line-height:1.2rem;}
    .follow_panel .follow_number{text-align:center;line-height:0.7rem;font-size:0.5rem;color:#fff;margin-top:0.1rem;}
    .header-more{width:2rem;height:2rem;line-height:2rem;position:absolute;top:0.5rem;right:0;color:#fff;text-align:center;font-size:1rem;}
    .header .background {background:#2c3b53;-webkit-filter: blur(0.5rem);filter: blur(0.5rem);height: 100%;left: 0;position: absolute;top: 0;width: 100%;z-index: -1;}
    .middle-popup{width:80%}
    .middle-popup img{max-width:100%}
    .box-wrapper{box-sizing: border-box; display: flex;align-content: flex-start; flex-shrink: 0;}
    .box-wrapper.v{-webkit-box-orient: vertical; flex-direction: column; }
    .box-wrapper.h{-webkit-box-orient: horizontal; flex-direction: row;}
    .box-wrapper .goods-price{ text-align: center;font-size: 0;display: block; font-weight: 500; color: rgb(255, 255, 255);position: absolute; place-content: flex-start center;  left: 0px; bottom: 0px; width: 2.61rem; height: .75rem; -webkit-box-pack: center; -webkit-box-align: center; align-items: center; border-bottom-left-radius: .15rem; border-bottom-right-radius: .15rem; background-color: rgba(0, 0, 0, 0.36);}
    .box-wrapper .goods-image{display: flex; width: 2.61rem; height: 2.61rem; border-radius: .15rem;}
    .box-wrapper .goods-wrapper{position: relative;  -webkit-box-align: center; align-items: center; width: 2.61rem; height: 2.61rem; margin-left: .3rem;}
    .box-wrapper .currency{font-size: .6rem;}
    .box-wrapper .price{font-size: .65rem;}
    .box-wrapper .goods-list{position: relative;  -webkit-box-align: center; align-items: center; margin-left: -.3rem; margin-top: .75rem;}
    .box-wrapper .live-title{position: relative; display: block; font-size: .8rem; width: 6.27rem; line-height: .75rem; font-weight: 500; color: rgb(255, 255, 255); text-overflow: ellipsis; white-space: nowrap; overflow: hidden;}
    .box-wrapper .live-desc{position: relative; height: .75rem; margin-top: .5rem;}
    .box-wrapper .live-count{position: absolute; display: block;  font-size: .65rem; left: 0px; top: 0px; height: .75rem; margin-left: 2.76rem; line-height: .75rem; color: rgb(255, 255, 255);}
    .box-wrapper .live-icon{display: flex; width: 2.46rem; height: .75rem;}
    .box-wrapper .live-btn{position: absolute; place-content: flex-start center; top: 0px; right: 0px; -webkit-box-pack: center; -webkit-box-align: center; align-items: center; width: 3.56rem; height: 1.35rem; border-radius: .68rem; background-color: rgb(255, 255, 255);}
    .box-wrapper .live-btn-text{position: relative; display: block;  font-size: .65rem; color: rgb(255, 52, 103);}
    .box-wrapper .left{position: relative; width: 5.6rem; height: 5.6rem;}
    .box-wrapper .right{position: relative; flex: 1 1 0%; -webkit-box-flex: 1; margin-left: .5rem;}
    .box-wrapper .live-info{position: relative;  margin-top: .25rem;}
    .box-wrapper .live-store{position: absolute; display: block; font-size: .6rem; left: 0px; top: 0px; background-color: rgba(0, 0, 0, 0.36); border-top-left-radius: .3rem; border-bottom-right-radius: .75rem; padding: .075rem .5rem .075rem .35rem; color: rgb(255, 255, 255);}
    .box-wrapper .live-image{position: relative;  height: 5.6rem; width: 5.6rem; border-radius: .3rem; overflow: hidden;background:#000}
    .box-wrapper .live-image img{width:100%;height: 100%}
    .box-wrapper .live-image video{width:100%;height: 100%}
    .box-wrapper .live-back-wrapper{position: absolute;  left: 0px; top: 0px; width: 100%; overflow: hidden; height: 8rem;}
    .box-wrapper .live-back-image{display: flex; width: 100%; height: 8rem; transform: scale(4); object-fit: cover;}
    .box-wrapper .live-back-cover{position: absolute;  left: 0px; top: 0px; right: 0px; bottom: 0px; background-color: rgba(0, 0, 0, 0.2);}
    .box-wrapper.live-wrapper{position: relative;  width: 100%; height: 6.8rem; padding: .6rem; overflow: hidden;}
</style>
